{
  "actionButtons": {
    "deselectAll": "deselectAll",
    "export": "export",
    "exportAsCsv": "exportAsCsv",
    "exportAsPdf": "exportAsPdf",
    "selectAll": "selectAll"
  },
  "areYouSureModal": {
    "cancelText": "cancelText",
    "confirmText": "confirmText",
    "title": "title"
  },
  "columnManager": {
    "columns": "columns",
    "hiddenColumns": "hiddenColumns",
    "noColumnsMatch": "noColumnsMatch",
    "pinnedColumns": "pinnedColumns",
    "searchPlaceholder": "searchPlaceholder",
    "visibleColumns": "visibleColumns"
  },
  "coordinates": {
    "latitude": "latitude",
    "latitudePlaceholder": "latitudePlaceholder",
    "latitudeTooltip": "latitudeTooltip",
    "longitude": "longitude",
    "longitudePlaceholder": "longitudePlaceholder",
    "longitudeTooltip": "longitudeTooltip"
  },
  "copy": "{{text}} copiato negli appunti",
  "countries": {
    "AC": "Isola di Ascensione",
    "AD": "Andorra",
    "AE": "Emirati Arabi Uniti",
    "AF": "Afghanistan",
    "AG": "Antigua e Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Antartide",
    "AR": "Argentina",
    "AS": "Samoa Americane",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "Isole Åland",
    "AZ": "Azerbaigian",
    "BA": "Bosnia-Erzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgio",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrein",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barthélemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivia",
    "BQ": "Paesi Bassi caraibici",
    "BR": "Brasile",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Isola Bouvet",
    "BW": "Botswana",
    "BY": "Bielorussia",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Isole Cocos (Keeling)",
    "CD": "Congo-Kinshasa",
    "CF": "Repubblica Centrafricana",
    "CG": "Congo-Brazzaville",
    "CH": "Svizzera",
    "CI": "Costa d'Avorio",
    "CK": "Isole Cook",
    "CL": "Cile",
    "CM": "Camerun",
    "CN": "Cina",
    "CO": "Colombia",
    "CP": "Isola Clipperton",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Capo Verde",
    "CW": "Curaçao",
    "CX": "Isola Christmas",
    "CY": "Cipro",
    "CZ": "Repubblica Ceca",
    "DE": "Germania",
    "DG": "Diego Garcia",
    "DJ": "Gibuti",
    "DK": "Danimarca",
    "DM": "Dominica",
    "DO": "Repubblica Dominicana",
    "DZ": "Algeria",
    "EA": "Ceuta e Melilla",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egitto",
    "EH": "Sahara Occidentale",
    "ER": "Eritrea",
    "ES": "Spagna",
    "ET": "Etiopia",
    "EU": "Unione Europea",
    "FI": "Finlandia",
    "FJ": "Figi",
    "FK": "Isole Falkland",
    "FM": "Micronesia",
    "FO": "Isole Faroe",
    "FR": "Francia",
    "GA": "Gabon",
    "GB": "Regno Unito",
    "GD": "Grenada",
    "GE": "Georgia",
    "GF": "Guyana Francese",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibilterra",
    "GL": "Groenlandia",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadalupa",
    "GQ": "Guinea Equatoriale",
    "GR": "Grecia",
    "GS": "Georgia del Sud e Isole Sandwich Meridionali",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "RAS di Hong Kong",
    "HM": "Isole Heard e McDonald",
    "HN": "Honduras",
    "HR": "Croazia",
    "HT": "Haiti",
    "HU": "Ungheria",
    "IC": "Isole Canarie",
    "ID": "Indonesia",
    "IE": "Irlanda",
    "IL": "Israele",
    "IM": "Isola di Man",
    "IN": "India",
    "IO": "Territorio Britannico dell'Oceano Indiano",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Islanda",
    "IT": "Italia",
    "JE": "Jersey",
    "JM": "Giamaica",
    "JO": "Giordania",
    "JP": "Giappone",
    "KE": "Kenya",
    "KG": "Kirghizistan",
    "KH": "Cambogia",
    "KI": "Kiribati",
    "KM": "Comore",
    "KN": "Saint Kitts e Nevis",
    "KP": "Corea del Nord",
    "KR": "Corea del Sud",
    "KW": "Kuwait",
    "KY": "Isole Cayman",
    "KZ": "Kazakistan",
    "LA": "Laos",
    "LB": "Libano",
    "LC": "Santa Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lituania",
    "LU": "Lussemburgo",
    "LV": "Lettonia",
    "LY": "Libia",
    "MA": "Marocco",
    "MC": "Monaco",
    "MD": "Moldavia",
    "ME": "Montenegro",
    "MF": "Saint Martin",
    "MG": "Madagascar",
    "MH": "Isole Marshall",
    "MK": "Macedonia del Nord",
    "ML": "Mali",
    "MM": "Myanmar (Birmania)",
    "MN": "Mongolia",
    "MO": "RAS di Macao",
    "MP": "Isole Marianne Settentrionali",
    "MQ": "Martinica",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldive",
    "MW": "Malawi",
    "MX": "Messico",
    "MY": "Malesia",
    "MZ": "Mozambico",
    "NA": "Namibia",
    "NC": "Nuova Caledonia",
    "NE": "Niger",
    "NF": "Isola Norfolk",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Paesi Bassi",
    "NO": "Norvegia",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Nuova Zelanda",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Perù",
    "PF": "Polinesia Francese",
    "PG": "Papua Nuova Guinea",
    "PH": "Filippine",
    "PK": "Pakistan",
    "PL": "Polonia",
    "PM": "Saint Pierre e Miquelon",
    "PN": "Isole Pitcairn",
    "PR": "Porto Rico",
    "PS": "Territori palestinesi",
    "PT": "Portogallo",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Riunione",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Ruanda",
    "SA": "Arabia Saudita",
    "SB": "Isole Salomone",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Svezia",
    "SG": "Singapore",
    "SH": "Sant'Elena",
    "SI": "Slovenia",
    "SJ": "Svalbard e Jan Mayen",
    "SK": "Slovacchia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "Sudan del Sud",
    "ST": "São Tomé e Príncipe",
    "SV": "El Salvador",
    "SX": "Sint Maarten (parte olandese)",
    "SY": "Siria",
    "SZ": "Eswatini",
    "TA": "Tristan da Cunha",
    "TC": "Isole Turks e Caicos",
    "TD": "Ciad",
    "TF": "Territori Francesi del Sud",
    "TG": "Togo",
    "TH": "Thailandia",
    "TJ": "Tagikistan",
    "TK": "Tokelau",
    "TL": "Timor Est",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turchia",
    "TT": "Trinidad e Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "UA": "Ucraina",
    "UG": "Uganda",
    "UM": "Isole minori esterne degli Stati Uniti",
    "UN": "Sconosciuto",
    "US": "Stati Uniti",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VA": "Città del Vaticano",
    "VC": "Saint Vincent e Grenadine",
    "VE": "Venezuela",
    "VG": "Isole Vergini Britanniche",
    "VI": "Isole Vergini Americane",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis e Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "Sud Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
  },
  "countriesEcobalyse": {
    "BD": "BD",
    "CN": "CN",
    "FR": "FR",
    "IN": "IN",
    "KH": "KH",
    "MA": "MA",
    "MM": "MM",
    "PK": "PK",
    "RAF": "RAF",
    "RAS": "RAS",
    "REE": "REE",
    "REO": "REO",
    "RLA": "RLA",
    "RME": "RME",
    "RNA": "RNA",
    "ROC": "ROC",
    "TN": "TN",
    "TR": "TR",
    "VN": "VN"
  },
  "dataLoad": {
    "error": {
      "message": "Non siamo riusciti a recuperare i dati richiesti. Si prega di ricaricare la pagina",
      "title": "Si è verificato un errore"
    },
    "noResults": {
      "message": "Non sono stati trovati dati relativi alla tua azienda. Si prega di riprovare più tardi.",
      "title": "Nessun risultato"
    }
  },
  "documentUpload": {
    "helptext": "Dimensione massima: {{ maxSize }}MB",
    "missingDocument": "missingDocument",
    "title": "Carica i tuoi file qui o fai clic per selezionarli manualmente",
    "uploadSuppliers": "uploadSuppliers"
  },
  "error": {
    "default": "Si è verificato un errore",
    "message": "message",
    "title": "title"
  },
  "fabricProcess": {
    "knitting-circular": "knitting-circular",
    "knitting-fully-fashioned": "knitting-fully-fashioned",
    "knitting-integral": "knitting-integral",
    "knitting-mix": "knitting-mix",
    "knitting-straight": "knitting-straight",
    "weaving": "weaving"
  },
  "filter": "filter",
  "form": {
    "reset": "reset",
    "save": "save"
  },
  "languages": {
    "arabic": "Arabo",
    "belarusian": "Bielorusso",
    "chinese": "Cinese",
    "dutch": "Olandese",
    "english": "Inglese",
    "french": "Francese",
    "german": "Tedesco",
    "italian": "Italiano",
    "japanese": "Giapponese",
    "korean": "Coreano",
    "lithuanian": "Lituano",
    "portuguese": "Portoghese",
    "romanian": "Rumeno",
    "spanish": "Spagnolo",
    "turkish": "Turco"
  },
  "lists": {
    "noData": {
      "title": "Nessun dato"
    }
  },
  "menus": {
    "admin": "Amministratore",
    "businessPartners": "Società commerciali",
    "certificates": "Certificati",
    "communicationStudio": "Studio",
    "dashboard": "Dashboard",
    "dataTransfer": "Trasferimento dati",
    "faq": "Domande frequenti",
    "invoices": "invoices",
    "logout": "Disconnetti",
    "products": "Prodotti",
    "profile": "profile",
    "regulations": "regulations"
  },
  "showOnlyMainFabric": "showOnlyMainFabric",
  "simulation": {
    "notSubscribed": {
      "message": "message",
      "title": "title"
    }
  },
  "sort": {
    "ascending": "ascending",
    "descending": "descending",
    "search": {
      "placeholder": "placeholder"
    },
    "title": "title"
  },
  "success": {
    "message": "azione completata con successo",
    "title": "successo"
  },
  "supplier": {
    "footer": {
      "privacyPolicy": "privacyPolicy"
    },
    "menu": {
      "contacts": "Contatti",
      "documentation": "Domande frequenti e Guida utente",
      "loggedAs": "Hai effettuato l'accesso come",
      "productionSites": "Siti di produzione",
      "requests": "Richieste clienti",
      "supplierRequests": "Monitoraggio fornitori"
    }
  },
  "table": {
    "filter": {
      "date": {
        "preset": {
          "custom": "custom",
          "oneMonthAgo": "oneMonthAgo",
          "oneMonthFromNow": "oneMonthFromNow",
          "oneWeekAgo": "oneWeekAgo",
          "oneWeekFromNow": "oneWeekFromNow",
          "oneYearAgo": "oneYearAgo",
          "oneYearFromNow": "oneYearFromNow",
          "today": "today",
          "tomorrow": "tomorrow",
          "yesterday": "yesterday"
        }
      },
      "operator": {
        "after": "after",
        "afterOrEquals": "afterOrEquals",
        "before": "before",
        "beforeOrEquals": "beforeOrEquals",
        "between": "between",
        "empty": "empty",
        "equals": "equals",
        "isEmpty": "isEmpty",
        "isNotEmpty": "isNotEmpty",
        "notBetween": "notBetween",
        "notEmpty": "notEmpty",
        "notEquals": "notEquals"
      }
    },
    "hideColumn": "hideColumn",
    "manageColumns": "manageColumns",
    "noDataMessage": "noDataMessage",
    "noDataTitle": "noDataTitle",
    "pinColumn": "pinColumn",
    "rowsPerPage": "Righe per pagina",
    "showColumn": "showColumn",
    "total": "Totale: ",
    "unpinColumn": "unpinColumn",
    "views": {
      "add": {
        "error": {
          "message": "Errore nella creazione della vista",
          "title": "Errore nella creazione della vista"
        },
        "success": {
          "message": "Vista creata con successo",
          "title": "Vista creata"
        }
      },
      "delete": {
        "error": {
          "message": "Errore nell'eliminazione della vista",
          "title": "Errore nell'eliminazione della vista"
        },
        "modal": {
          "cancel": "Annulla",
          "delete": "Elimina",
          "description": "Sei sicuro di voler eliminare la vista {{viewName}} ? Questa azione è irreversibile.",
          "title": "Conferma"
        },
        "success": {
          "message": "Vista eliminata con successo",
          "title": "Vista eliminata"
        }
      },
      "modal": {
        "description": "Salva la vista attiva della tabella di dati per accedere a essa più tardi. L'ordinamento, il filtraggio e la configurazione delle colonne verranno salvati.",
        "pinnedToDashboard": {
          "label": "label",
          "tooltip": "tooltip"
        },
        "reset": "Reimposta",
        "save": "Salva (beta)",
        "title": "Vista attiva (beta)",
        "update": "Aggiorna"
      },
      "update": {
        "error": {
          "message": "Errore nell'aggiornamento della vista",
          "title": "Errore nell'aggiornamento della vista"
        },
        "success": {
          "message": "Vista aggiornata con successo",
          "title": "Vista aggiornata"
        }
      },
      "viewName": "Nome della vista",
      "viewNamePlaceholder": "Inserisci il nome della vista"
    }
  },
  "zodErrors": {
    "errorDefault": "Valore non valido",
    "invalidEmail": "Indirizzo email non valido",
    "latitudeOutOfRange": "latitudeOutOfRange",
    "longitudeOutOfRange": "longitudeOutOfRange",
    "mustContainBothLatitudeAndLongitude": "mustContainBothLatitudeAndLongitude",
    "noSpecialCharacters": "Il valore deve contenere più di 2 caratteri e non deve contenere caratteri speciali",
    "ValueTooLong": "Valore troppo lungo",
    "ValueTooShort": "Valore troppo corto"
  }
}
